import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './shared/styles/base.css'
// Importar la configuración de Amplify
import './shared/config/amplify'
// Importar y mostrar versión de la aplicación
import { logAppVersion } from './shared/version'

// Mostrar información de versión en consola al iniciar la app
logAppVersion()

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
)
